import Main from "../../common/Main/Main";
import Loadspinner from "../../common/Loadspinner";
import React, { useState, useEffect, useCallback } from "react";
import { getAllKnowledgeBaseData } from "../../helpers/API/APIEndPoints";
import { APICall } from "../../helpers/API/APICalls";
import {
  Avatar,
  Badge,
  Card,
  CardContent,
  CardMedia,
  Chip,
  Divider,
} from "@mui/material";
import { Modal, Typography } from "@material-ui/core";
import { OverflowTip } from "../../ReusableComponents/OverFlowTip/OverflowTip";
import * as images from "../../constants/Images";
import { downloadBlob } from "../../services/CommonService";
import { Encrypt } from "../../helpers/Cryptography/CryptoJS";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import "./KnowledgeBase.css";
import PropTypes from "prop-types";
import CommonConstants from "../../constants/CommonConstants";
import { getFromEncLocalStorage, storeInEncLocalStorage } from "../../helpers/Utils/Utils";

const KnowledgeBase = () => {
  let history = useHistory();
  const [loading, setLoading] = useState(false);
  const [knowledgeBase, setKnowledgeBase] = useState([]);
  const [pageSize, setPageSize] = useState(Number.MAX_SAFE_INTEGER);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("Sequence");
  const [sortDirection, setSortDirection] = useState("asc");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  let key;
  let details = [];
  let data1 = [];

  useEffect(() => {
    getBookmarks();
  }, [searchText]);


  const getBookmarks = async () => {
    setLoading(true);
    const employeeNum = getFromEncLocalStorage("employeenumber");

    let requestParams = {
      start: start,
      resultsPerPage: pageSize,
      searchText: searchText,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
      userId: employeeNum,
      isExport: false,
    };
    let res = await APICall(getAllKnowledgeBaseData, requestParams);
    if (res.message === "Ok") {
      if (res && res.data.length > 0) {
        for (let index = 0; index < res?.data?.length; index++) {
          const kb = res.data[index];
          kb.Icon = kb.Icon ? await downloadBlob(kb.Icon) : kb.Icon;
          kb.BannerImage = kb.BannerImage
            ? await downloadBlob(kb.BannerImage)
            : kb.BannerImage;
        }

        setKnowledgeBase(res.data);
        // setCount(res.totalCount);
      }
    }

    setLoading(false);
  };

  async function handleClick(url, Id) {
    storeInEncLocalStorage("tokennumber", await Encrypt(JSON.stringify(Id)));
    history.push({
      pathname: `${url}`,
    });
  }

  const KnowledegeBaseCard = ({ event }) => {
    return (
      <Card
        sx={{ maxWidth: 300, margin: 1, padding: 0 }}
        id={event.Id}
        elevation={5}
        onClick={(e) => {
          e.preventDefault();
          handleClick(`/knowledgeBase/${event.Id}`, event.Id);
        }}
      >
        <CardMedia
          sx={{ height: 140 }}
          image={event?.BannerImage} //event?.value[0].localUrl || event?.value[0].globalUrl
          className="card-img"
        >
          <div
            style={{
              position: "relative",
              display: "flex",
              justifyContent: "center",
              alignItems: "flex-end",
              height: "inherit",
            }}
          >
            <Badge
              style={{ position: "absolute", bottom: "-1.6rem" }}
              overlap="circular"
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              badgeContent={event?.knowledgeCount || 0}
              color="primary"
            >
              <Avatar src={event?.Icon} sx={{ width: 56, height: 56 }} />
            </Badge>
          </div>
        </CardMedia>

        <CardContent sx={{ marginTop: 2 }}>
          <Typography variant="h6" component="span">
            {event.Name}
          </Typography>

          <div className="py-2" style={{ color: "grey" }}>
            <OverflowTip lineCount={3}>
              <Typography variant="subtitle1" component={"span"} noWrap={false}>
                {event.Description}
              </Typography>
            </OverflowTip>
          </div>
        </CardContent>
      </Card>
    );
  };
  KnowledegeBaseCard.propTypes = {
    event: PropTypes.object,
  };

  return (
    <Main active={"knowledge"} removeContainer={true}>
      <Loadspinner filename="KnowledgeBase.js" isLoading={loading} isMiddle="false" />
      <div className="eventGallery">
        <div className="col-lg-12">
          <div className="row">
            <div className="col-md-4">
              <h4 style={{ paddingLeft: "15px", fontWeight: "bold" }}>
                Discover Knowledge
              </h4>
            </div>
            <div className="display-col aside-card">
              <div className="search-bar">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control search-input"
                    value={searchText}
                    placeholder="Search"
                    onChange={(e) => setSearchText(e.target.value)}
                    autoComplete={CommonConstants.autoCompleteInput}
                  />
                  <button
                    className="btn search-btn"
                    type="button"
                    onClick={() => getBookmarks()}
                  >
                    <img src={images.search} className="search-icons" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="clearfix"></div>

      <div className="display-row justify-space-between">
        {knowledgeBase.length > 0 ? (
          <div className="container my-3">
            <div className="row">
              {knowledgeBase.map((event, index) => {
                return (
                  <KnowledegeBaseCard event={event} key={`event_${index}`} />
                );
              })}
            </div>
          </div>
        ) : null}
      </div>
    </Main>
  );
};
export default KnowledgeBase;
